export const ROUTES = {
  home: "/sales-enablement/disclosures",
  create: "/sales-enablement/disclosures/new",
  update: (id: string) => `/sales-enablement/disclosures/${id}`,
};

export const QUERY_KEYS = {
  fetchDisclosures: "fetchDisclosures",
};
